export const NOTIFICATION_TYPE = {
  success: "success",
  error: "error",
};
